<div class="card">
    <div class="card-header card-header-squirrel">
        <h4>Mandanten löschen</h4>
    </div>
    <div class="card-body">
        <form [formGroup]="deleteTenantForm" novalidate>
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field class="example-full-width" style="width: 0; height: 0;">
                        <input matInput hidden  formControlName="id" readonly>
                    </mat-form-field>
                </div>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <mat-form-field class="example-full-width">
                        <input matInput formControlName="name" readonly>
                    </mat-form-field>
                </div>
            </div>
        </form>
        <div class="row">
            <a>
            <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;margin-left: 0px" matTooltip="Dialog schließen"
                            (click)="cancel()" >Abbruch</button>
            </a>                                                
            <span style="flex: 1 1 auto"></span>
            <a>
                    <button mat-raised-button class="btn btn-squirrel" style="margin-top: 6px;" matTooltip="Mandanten löschen"
                                    (click)="deleteTenant(tenantDto.id)" >Löschen</button>
            </a>                   
        </div>
    </div>
</div>